#@import Booking.Presenters.Base
#@export Booking.Presenters.TimeBubble

class Booking.Presenters.TimeBubble extends Booking.Presenters.Base

  toHash: ->
    timeFormat = @getI18n().t('.timeFormat')
    time: @model.start().format(timeFormat)
    selected: @model.isSelected()
    disabled: @model.isDisabled()
    bhc: 'li:timeBubble'
